import * as React from "react"
import {Skeleton, Box} from "@mui/material"
import {AmchartSeeker} from "@ui-seeker/core"

import PriceDiscountOffersEvolutionChartToolbar from "./Toolbar";
import { usePricingDiscountOffersEvolutionData } from "./@hooks";



export default function PriceDiscountOffersEvolutionChart() {

    const {
        dataEvolution, dataEvolutionKeys, isLoadingDataEvolution,
        chartColor, dateRange, onChange, resetEvolutionData
    } = usePricingDiscountOffersEvolutionData()
    
    if (isLoadingDataEvolution) return <Skeleton variant="rectangular" height={1000} />
	if (!dataEvolution?.length) return <></>
    
    return <AmchartSeeker
        rootID={'OffersEvolutionChart'}
        data={dataEvolution}
        title={<Box id="evolution-chart">Offers Comparison Evolution </Box>}
        series={dataEvolutionKeys.map(key => ({
            name: key, yField: key,
            xField: "date",
            connect: true,
            stacked: true,
            color: chartColor[key],
            fills: {
                fillOpacity: 0.5,
                visible:true
            }
        }))}
        chartProps={{
            numberFormat: `#,###.00  %`,
            dateFormatReceived: 'yyyyMMdd',
            xAxis: {
                categoryField: 'date',
                isDateAxis: true,
                dateFormat: 'dd MMM yyyy',
                baseInterval: {
                    timeUnit: 'day',
                    count: 1
                }
            }
        }}
        cardProps={{ actions: <PriceDiscountOffersEvolutionChartToolbar handleClick={resetEvolutionData} dateRange={dateRange} onChange={onChange}/> }}
        sx={{ height: 500 }}
    />
}